import { useState } from "react";
import { Moon, Sun } from "lucide-react";

const KEY = "rc_theme";

export const applyStoredTheme = () => {
  document.documentElement.classList.toggle("light", localStorage.getItem(KEY) !== "dark");
};

export const ThemeToggle = ({ className = "" }) => {
  const [light, setLight] = useState(() => document.documentElement.classList.contains("light"));
  const toggle = () => {
    const next = !light;
    document.documentElement.classList.toggle("light", next);
    localStorage.setItem(KEY, next ? "light" : "dark");
    setLight(next);
  };
  return (
    <button data-testid="theme-toggle" onClick={toggle} aria-label={light ? "Ativar modo escuro" : "Ativar modo claro"} title={light ? "Modo escuro" : "Modo claro"}
      className={`flex h-9 w-9 items-center justify-center rounded-full border border-white/15 text-white transition-colors hover:bg-white/10 ${className}`}>
      {light ? <Moon className="h-4 w-4" /> : <Sun className="h-4 w-4" />}
    </button>
  );
};
